<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <form [formGroup]="updateForm" enctype="multipart/form-data">
      <div class="form-group">
        <label>اســم القســـم</label>
        <input
          formControlName="Title"
          [class.is-invalid]="Title.invalid && Title.touched"
          type="text"
          class="form-control"
        />
        <div *ngIf="Title.errors && Title.invalid && Title.touched">
          <small class="text-danger" *ngIf="Title.errors?.required">
            اسم القســـم مطلوب
          </small>
          <small class="text-danger" *ngIf="Title.errors.minlength">
            اقل عدد احرف مسموح بها 3 احروف
          </small>
          <small class="text-danger" *ngIf="Title.errors.maxlength">
            اكبر عدد احرف مسموح بها 15 احروف
          </small>
          <small *ngIf="Title.errors?.forbiddenName">
            {{ Title.errors?.forbiddenName.value }} غير مسموح بيه
          </small>
        </div>
      </div>

      <div class="form-group">
        <label>الوصـــف</label>
        <input
          formControlName="Description"
          [class.is-invalid]="Description.invalid && Description.touched"
          type="text"
          class="form-control"
        />
        <div
          *ngIf="
            Description.errors && Description.invalid && Description.touched
          "
        >
          <small class="text-danger" *ngIf="Description.errors?.required">
            الوصف مطلوب
          </small>
          <small class="text-danger" *ngIf="Description.errors.minlength">
            اقل عدد احرف مسموح بها 50 احروف
          </small>
        </div>
      </div>

      <div class="form-group row d-flex justify-content-between align-items-center mt-3">
        <div class="progress col-lg-3 mt-3" *ngIf="existingFile">
          <div
            class="progress-bar progress-bar-striped bg-danger"
            attr.aria-valuenow="{{ progress }}"
            aria-valuemin="0"
            aria-valuemax="100"
            [ngStyle]="{ width: progress + '%' }"
          >
            {{ progress }}%
          </div>
        </div>

        <label class="btn btn-default col-lg-3 mt-3">
          <input type="file" (change)="chooseFile($event)" />
        </label>

        <img class="img-fluid col-lg-3 mt-3"
          src="https://khairokom-uploadfiles.azurewebsites.net/files/{{fileName}}"/>

        <button
          class="upload btn btn-primary col-lg-2 mt-3"
          [disabled]="!chosenFiles"
          (click)="upload()"
        >
          رفع الصـــورة
        </button>

        <div class="alert alert-light">{{ msg }}</div>
      </div>

      <button type="submit" class="update btn btn-success" (click)="update()">
        تعديـــل
      </button>
    </form>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
